import { render, staticRenderFns } from "./UniversalRunForm.vue?vue&type=template&id=572933da&"
import script from "./UniversalRunForm.vue?vue&type=script&lang=js&"
export * from "./UniversalRunForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports